module.exports = __webpack_public_path__ + "media/images/athletes/3122-5cc62fb99082925757202bdd76b5e8d4.png";